import { computed, makeObservable } from 'mobx'

import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

import type { PolicyTarget } from 'modules/permissions/store/collections/policyAuthorizations'

interface IReview {
  [key: string]: any
}

class Review extends Model<IReview> implements PolicyTarget {
  static urlRoot() {
    return '/reviews/reviews'
  }

  static Status = {
    approved: 'approved',
    pending: 'pending',
    rejected: 'rejected',
  }

  constructor(attr: IReview = {}) {
    super(attr)
    makeObservable(this, {
      isPending: computed,
      isSubmitted: computed,
      isRejected: computed,
      isApproved: computed,
    })
  }

  get policyTargetClass(): string {
    return '::Reviews::Review'
  }

  get statusLabel(): string {
    const status: Record<string, string> = {
      [Review.Status.approved]: i18n.t('expenses_v2.review.status.approved'),
      [Review.Status.pending]: i18n.t('expenses_v2.review.status.pending'),
      [Review.Status.rejected]: i18n.t('expenses_v2.review.status.rejected'),
    }

    return status[this.attributes.state] || ''
  }

  get isPending(): boolean {
    return this.attributes.state === Review.Status.pending
  }

  get isSubmitted(): boolean {
    return !this.isPending
  }

  get isRejected(): boolean {
    return this.attributes.state === Review.Status.rejected
  }

  get isApproved(): boolean {
    return this.attributes.state === Review.Status.approved
  }
}

export default Review
